import { useEffect } from 'react';

/**
 * Listens to global animation and transition end events and calls the
 * provided callback once all events have ended. This is useful for
 * updating the app state after animations have completed.
 *
 * @param {function} callback - The function to call once all animations
 * have ended.
 */
export function useGlobalMotionUpdate(callback) {
    useEffect(() => {
        if (!callback) return;

        let t;
        const kick = () => {
            clearTimeout(t);
            // small debounce to coalesce multiple end events
            t = setTimeout(() => callback(), 50);
        };

        // capture both transitions and animations
        const events = ['transitionend', 'animationend', 'transitioncancel', 'animationcancel'];

        events.forEach((e) => document.addEventListener(e, kick, { passive: true, capture: true }));
        return () => {
            clearTimeout(t);
            events.forEach((e) => document.removeEventListener(e, kick, { capture: true }));
        };
    }, [callback]);
}
